import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import './Register.css';
import { app,auth,facebookAuthProvider } from "./base";

class Register extends Component{
    constructor(props, state){
        super(props);
        this.state = state;
        
        this.authWithEmailPassword = this.authWithEmailPassword.bind(this);
        this.authWithFacebook = this.authWithFacebook.bind(this);
        this.authWithGoogle = this.authWithGoogle.bind(this);
        this.handleClose = this.handleClose.bind(this);
        

    }
    componentWillMount() {
       this.setState({ redirect: false });
    }
    authWithEmailPassword(event){
    event.preventDefault();
    console.log("We're authing with Email & password");
    console.table([{
        email: this.emailInput.value,
        password: this.passwordInput.value,
        userName: this.userNameInput.value,
        }]);

        const userName = this.userNameInput.value;
        const email = this.emailInput.value;
        const password = this.passwordInput.value;
        let isNewUser = false; 

        // check if userNAme is unique and valid

        console.log(' Register app.validateUserName()',this.props.validateUserName(userName));

        auth.fetchProvidersForEmail(email).then((providers)=>{
            console.log('app.auth.fetchProvidersForEMail then (providers) ',providers);
            if(providers.length === 0) {
            // create user
                console.log('create user');
                isNewUser = true;
                return app.auth().createUserWithEmailAndPassword(email,password)
                    .then((user) => {
                        user.updateProfile({
                            displayName: userName
                        });
                        this.props.onNewUser(user,userName,email,password);
                        this.RegisterForm.reset()
                        this.setState({ redirect: true })
                        return user;
                    })
                    .catch(err=>console.error(err));
            } else if(providers.indexOf("password") === -1){
                console.log('Try alternative Register');
            } else {
                // log in user
                console.log('log in user');
                return app.auth().signInWithEmailAndPassword(email,password)
            }
        })
        .then((user) => {
                 //   displayName: userName
            console.log('--------------------user was logged in userName,user:',user,isNewUser);
            if(isNewUser){ 
                console.log('--------------------new user was logged in',userName);
                // save user to firebase : users with role : guest 1
                //let newUser = auth.currentUser;
               // newUser.updateProfile({
               //     displayName: userName
               // });
               // this.props.onNewUser(user,userName);
            }
            if (user && user.email) {
              this.RegisterForm.reset()
              this.setState({ redirect: true })
            }
          })
        .catch((error) => {
            
          });

    }
    authWithFacebook(){
        console.log("We're authing with Facebook");
    }
    authWithGoogle(){
        console.log("We're authing with Google");  
    }

    handleClose(event){
        console.log('handleClose',event);
        this.setState({
            redirect : true
        });
    }

    render(){
        console.log("this.state.redirect ",this.state.redirect );  
        return(
            this.state.redirect ? 
            <Redirect to="/"/>
            :
            <div className="modal is-active">
                <div onClick={this.handleClose} className="modal-background"></div>
                <div className="modal-content">
                <div className="box Register">
                    <header>
                        <h1>Registrieren</h1>
                        <p className="help">
                            Registrieren Sie sich bei uns als Nutzer um den On-Golf Event Kalender zu nutzen. 
                            Sie müssen dazu ein Alias Name (1 Wort) , Ihre E-Mail und ein Passwort hier eintragen. 
                            Ihre Registrierung wird von uns manuell geprüft und gegebenfalls freigeschaltet. 
                            Sie bekommen dann von uns ein Bestätigungs E-Mail und können Sich danach hier anmelden.  
                            Erst nach dieser Freischlatung können Sie on-golf Events Termine sehen, teilnehmen und selber Termine in dem Kalender eintragen.   
                        </p>
                        <p></p>  
                    </header>
                    <form onSubmit={(event)=> this.authWithEmailPassword(event)} ref={(form) => { this.RegisterForm = form }}>
                       

                        <div className="field">
                            <label class="label">Name (Alias)</label>
                            <p className="control has-icons-left has-icons-right">
                            <input ref={(input) =>{this.userNameInput = input}} name="username" className="input" type="text"  placeholder="Name(Alias)" required />
                                <span className="icon is-small is-left">
                                    <ion-icon name="person"></ion-icon>
                                </span>
                                    <span className="icon is-small is-right">
                                    <ion-icon name="checkmark"></ion-icon>
                                </span>
                            </p>
                            <p class="help">Ihr Nutzer Name ,Alias, bitte nur 1 Wort, keine Leerzeichen</p>
                        </div>

                        <div className="field">
                            <label class="label">E-Mail</label>
                            <p className="control has-icons-left has-icons-right">
                                <input required ref={(input) =>{this.emailInput = input}} name="email" className="input" type="email" placeholder="z.B. xyz@server.de" />
                                <span className="icon is-small is-left">
                                    <ion-icon name="mail"></ion-icon>
                                </span>
                                    <span className="icon is-small is-right">
                                    <ion-icon name="checkmark"></ion-icon>
                                </span>
                            </p>
                            <p class="help">Ein gültige E-Mail Adresse.</p>
                        </div>

                        <div className="field">
                            <label class="label">Passwort</label>
                            <p className="control has-icons-left has-icons-right">
                                <input required className="input" ref={(input) =>{this.passwordInput = input}} name="password" type="password" placeholder="Passwort" />
                                <span className="icon is-small is-left">
                                    <ion-icon name="lock"></ion-icon>
                                </span>
                                    <span className="icon is-small is-right">
                                    <ion-icon name="checkmark"></ion-icon>
                                </span>
                            </p>
                            <p class="help">Ein geheimes, nur Ihnen bekanntes Kennwort, bitte für Anmeldung merken.</p>
                        </div>

                       <div class="field is-grouped">
                            <div class="control">
                                  <input type="submit" className="button is-success button-primary" value="Absenden"></input>
                            </div>
                            <div class="control">
                            <button className="button is-text is-outlined has-margin-left"  onClick={this.handleClose}>Abbrechen</button>
                            </div>
                        </div> 

                       
                    </form>
                </div>
                </div>

         

           
            </div>

        ); 
    }
}

export default Register;


// WEBPACK FOOTER //
// ./src/Register.js